"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.defaultAppRecordsService = void 0;
const rxjs_1 = require("rxjs");
exports.defaultAppRecordsService = {
    recordsByTitleService: {
        fetchRecordsByTitles: async () => [],
    },
    ensureRecordsLoaded: () => undefined,
    getApplication: () => null,
    reloadRecords: () => undefined,
    getTagById: () => undefined,
    getTagByLabel: () => undefined,
    getAppStructure: () => null,
    getApplicationRecords: () => [],
    getCurrentMember: () => ({}),
    getMembers: () => [],
    checkUniqueness: () => (0, rxjs_1.of)(true),
    getRelatedRecord: () => undefined,
    getMultipleRelatedRecords: () => [],
    getFormulaApplicationSchema: () => null,
    getAllRecordsForApplication: () => [],
};
